import {
  EXTERNAL_LOAN_DEFAULT_DAILY_INTEREST_RATE_PERCENT,
  EXTERNAL_LOAN_PROTECTED_SAVINGS_PERCENTAGE,
  EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY,
  EXTERNAL_LOAN_STANDARD_INTEREST_PLAN,
} from '../constants/externalLoanConstants';

export const externalLoanSimulationStates = [
  { key: 'eligible', label: 'Eligible - Not Applied', phase: 'eligible', badge: 'Eligible' },
  { key: 'draft', label: 'Draft Application', phase: 'draft', badge: 'Draft' },
  { key: 'validation-failed', label: 'Additional Information Required', phase: 'validation-failed', badge: 'Needs Attention' },
  { key: 'submitted', label: 'Submitted', phase: 'submitted', badge: 'Submitted' },
  { key: 'awaiting-chairperson', label: 'Awaiting Chairperson Approval', phase: 'awaiting-chairperson', badge: 'Awaiting Chairperson' },
  { key: 'awaiting-secretary', label: 'Awaiting Guarantors', phase: 'awaiting-secretary', badge: 'Awaiting Guarantors' },
  { key: 'awaiting-accountant', label: 'Awaiting Accountant Approval', phase: 'awaiting-accountant', badge: 'Awaiting Accountant' },
  { key: 'provider-sync-pending', label: 'Submitting to Bellicks', phase: 'provider-sync-pending', badge: 'System Submission' },
  { key: 'provider-sync-failed', label: 'Bellicks Sync Needs Attention', phase: 'provider-sync-failed', badge: 'Sync Needs Attention' },
  { key: 'bellicks-submitted', label: 'Submitted to Bellicks', phase: 'bellicks-submitted', badge: 'Submitted to Bellicks' },
  { key: 'gm-review', label: 'Under Bellicks Review', phase: 'gm-review', badge: 'Under Review' },
  { key: 'approved', label: 'Approved - Pending Disbursement', phase: 'approved', badge: 'Approved' },
  { key: 'disbursed', label: 'Disbursed', phase: 'disbursed', badge: 'Disbursed' },
  { key: 'partially-repaid', label: 'Partially Repaid', phase: 'partially-repaid', badge: 'Repayment Active' },
  { key: 'overdue', label: 'Overdue', phase: 'overdue', badge: 'Overdue' },
  { key: 'fully-repaid', label: 'Completed', phase: 'fully-repaid', badge: 'Completed' },
  { key: 'rejected', label: 'Rejected', phase: 'rejected', badge: 'Rejected' },
  { key: 'cancelled', label: 'Cancelled', phase: 'cancelled', badge: 'Cancelled' },
];

const stateConfigByKey = externalLoanSimulationStates.reduce((acc, state) => ({ ...acc, [state.key]: state }), {});

const groups = [
  { name: 'Mwanza Savings Circle', code: 'MWZ-SC-42', leader: 'Hassan Omari', district: 'Mwanza' },
  { name: 'Kijitonyama Women Saccos', code: 'KJT-WM-18', leader: 'Neema Macha', district: 'Kinondoni' },
  { name: 'Dodoma Traders Group', code: 'DOM-TR-33', leader: 'Peter Lema', district: 'Dodoma Urban' },
  { name: 'Mbeya Teachers Saccos', code: 'MBY-TC-09', leader: 'Gloria Mwakalinga', district: 'Mbeya City' },
];

const applicantSeeds = [
  { memberName: 'Amina Mbarak', phoneNumber: '+255 712 345 678', memberReference: 'SVY-10482', employmentStatus: 'Employed', monthlyIncome: 850000, governmentIdNumber: '1234567890123456', dateOfBirth: '1989-03-12' },
  { memberName: 'Hassan Juma', phoneNumber: '+255 713 908 244', memberReference: 'SVY-10927', employmentStatus: 'Self-employed', monthlyIncome: 620000, governmentIdNumber: '1987765432109001', dateOfBirth: '1986-11-02' },
  { memberName: 'Salma Rashid', phoneNumber: '+255 714 667 112', memberReference: 'SVY-11208', employmentStatus: 'Business owner', monthlyIncome: 980000, governmentIdNumber: '1991040500887003', dateOfBirth: '1991-04-05' },
  { memberName: 'Joseph Msuya', phoneNumber: '+255 715 221 980', memberReference: 'SVY-11941', employmentStatus: 'Teacher', monthlyIncome: 740000, governmentIdNumber: '1988112200911006', dateOfBirth: '1988-12-22' },
  { memberName: 'Rehema Abdallah', phoneNumber: '+255 716 334 850', memberReference: 'SVY-12177', employmentStatus: 'Trader', monthlyIncome: 560000, governmentIdNumber: '1993061800512002', dateOfBirth: '1993-06-18' },
  { memberName: 'Daniel Masanja', phoneNumber: '+255 717 642 120', memberReference: 'SVY-12744', employmentStatus: 'Civil servant', monthlyIncome: 910000, governmentIdNumber: '1985021400448005', dateOfBirth: '1985-02-14' },
  { memberName: 'Ruth Kileo', phoneNumber: '+255 718 455 009', memberReference: 'SVY-13016', employmentStatus: 'Entrepreneur', monthlyIncome: 690000, governmentIdNumber: '1990082600329008', dateOfBirth: '1990-08-26' },
  { memberName: 'Fatuma Said', phoneNumber: '+255 719 771 305', memberReference: 'SVY-13302', employmentStatus: 'Market vendor', monthlyIncome: 510000, governmentIdNumber: '1995051200194004', dateOfBirth: '1995-05-12' },
  { memberName: 'Peter Komba', phoneNumber: '+255 752 601 444', memberReference: 'SVY-13790', employmentStatus: 'Logistics officer', monthlyIncome: 790000, governmentIdNumber: '1987043000645007', dateOfBirth: '1987-04-30' },
  { memberName: 'Neema Macha', phoneNumber: '+255 753 208 991', memberReference: 'SVY-14011', employmentStatus: 'Salon owner', monthlyIncome: 580000, governmentIdNumber: '1992072100756009', dateOfBirth: '1992-07-21' },
  { memberName: 'Baraka Ally', phoneNumber: '+255 754 342 710', memberReference: 'SVY-14439', employmentStatus: 'Driver', monthlyIncome: 470000, governmentIdNumber: '1990010900237001', dateOfBirth: '1990-01-09' },
  { memberName: 'Zainab Hamisi', phoneNumber: '+255 755 829 018', memberReference: 'SVY-14908', employmentStatus: 'Caterer', monthlyIncome: 640000, governmentIdNumber: '1994081600138002', dateOfBirth: '1994-08-16' },
  { memberName: 'Moses Mrema', phoneNumber: '+255 756 442 100', memberReference: 'SVY-15176', employmentStatus: 'Technician', monthlyIncome: 600000, governmentIdNumber: '1989120300390004', dateOfBirth: '1989-12-03' },
];

const collateralByIndex = [
  { type: 'Motor Vehicle', description: 'Toyota Noah 2019, insured and registered', estimatedValue: 6200000 },
  { type: 'Business Inventory', description: 'Retail shop stock and refrigerator equipment', estimatedValue: 2100000 },
  { type: 'Motorcycle', description: 'Boxer BM150, registered for delivery business', estimatedValue: 1800000 },
  { type: 'Salary Assignment', description: 'Employer-confirmed monthly salary assignment', estimatedValue: 2500000 },
  { type: 'Group Savings Pledge', description: 'Member savings pledge approved by group leadership', estimatedValue: 1200000 },
];

const approvalActors = [
  { role: 'Chairperson', name: 'Joseph Msuya', phone: '+255 714 112 233' },
  { role: 'Secretary', name: 'Ruth Kileo', phone: '+255 715 778 899' },
  { role: 'Accountant', name: 'Daniel Masanja', phone: '+255 716 445 566' },
];

const money = (value) => Math.round(Number(value || 0));

const monthlyDueDate = (index) => {
  const zeroBasedMonth = 8 + index;
  const year = 2026 + Math.floor(zeroBasedMonth / 12);
  const month = (zeroBasedMonth % 12) + 1;
  return `${year}-${String(month).padStart(2, '0')}-15`;
};

const createRepaymentSchedule = (totalPayable, termMonths, amountPaid = 0, overdueInstallments = 0) => {
  const installmentAmount = money(totalPayable / termMonths);
  let remainingPaid = money(amountPaid);
  return Array.from({ length: termMonths }, (_, index) => {
    const paidAmount = Math.min(installmentAmount, remainingPaid);
    remainingPaid -= paidAmount;
    const balance = installmentAmount - paidAmount;
    const isPastDue = index < overdueInstallments && balance > 0;
    return {
      installment: index + 1,
      dueDate: monthlyDueDate(index),
      expectedAmount: installmentAmount,
      paidAmount,
      balance,
      status: balance === 0 ? 'Paid' : isPastDue ? 'Overdue' : 'Upcoming',
      paymentReference: paidAmount > 0 ? `PMT-${String(index + 1).padStart(3, '0')}` : '-',
      paidDate: paidAmount > 0 ? monthlyDueDate(index) : '-',
    };
  });
};

const createGuarantors = (completedCount, rejectedBy = null, rejectionReason = null) => approvalActors.map((actor, index) => {
  const isRejected = rejectedBy === actor.role;
  const status = isRejected ? 'rejected' : index < completedCount ? 'approved' : 'pending';
  return {
    ...actor,
    status,
    approved: status === 'approved',
    rejected: status === 'rejected',
    approvedAt: status === 'approved' ? `2026-08-${String(2 + index).padStart(2, '0')} 10:15` : null,
    rejectedAt: status === 'rejected' ? `2026-08-${String(2 + index).padStart(2, '0')} 15:40` : null,
    rejectionReason: status === 'rejected' ? rejectionReason : null,
  };
});

const createSnapshot = ({
  id,
  referenceNumber,
  stateKey,
  applicantIndex,
  groupIndex,
  requestedAmount,
  approvedAmount = requestedAmount,
  currentSavings,
  termMonths = 6,
  interestRate = 0.12,
  fees = 25000,
  repaymentFrequency = 'Monthly',
  amountPaid = 0,
  overdueAmount = 0,
  overdueDays = 0,
  guarantorApprovals = 0,
  rejectedBy = null,
  applicationDate,
  lastUpdated,
  status,
  currentStage,
  reviewStage,
  reviewer = 'GM - Salma Komba',
  reviewStatus,
  reviewNotes,
  contractGeneratedAt,
  rejectionReason = null,
  completionDate = null,
  cancelledReason = null,
}) => {
  const stateConfig = stateConfigByKey[stateKey] || stateConfigByKey.eligible;
  const applicant = applicantSeeds[applicantIndex % applicantSeeds.length];
  const group = groups[groupIndex % groups.length];
  const protectedSavingsPercentage = EXTERNAL_LOAN_PROTECTED_SAVINGS_PERCENTAGE;
  const protectedAmount = money(currentSavings * protectedSavingsPercentage);
  const eligibleAmount = money(currentSavings - protectedAmount);
  const interest = money(approvedAmount * interestRate);
  const totalPayable = money(approvedAmount + interest + fees);
  const safeAmountPaid = Math.min(money(amountPaid), totalPayable);
  const outstandingAmount = Math.max(totalPayable - safeAmountPaid, 0);
  const repaymentAmount = money(totalPayable / termMonths);
  const isCompleted = stateKey === 'fully-repaid';
  const isDisbursed = ['disbursed', 'partially-repaid', 'overdue', 'fully-repaid'].includes(stateKey);
  const finalContractStatus = ['eligible', 'draft', 'validation-failed'].includes(stateKey)
    ? 'Not Generated'
    : stateKey === 'rejected' || stateKey === 'cancelled'
      ? 'Archived'
      : 'Generated';
  const repaymentSchedule = createRepaymentSchedule(totalPayable, termMonths, safeAmountPaid, overdueAmount > 0 ? 1 : 0);

  return {
    id,
    stateKey,
    stateConfig,
    referenceNumber,
    applicant: applicant.memberName,
    amount: requestedAmount,
    status,
    currentStage,
    applicationDate,
    lastUpdated,
    outstandingAmount,
    statusGroup: ['draft', 'validation-failed', 'submitted', 'awaiting-chairperson', 'awaiting-secretary', 'awaiting-accountant', 'provider-sync-pending', 'provider-sync-failed'].includes(stateKey)
      ? 'pending'
      : ['gm-review'].includes(stateKey)
        ? 'review'
        : ['approved'].includes(stateKey)
          ? 'approved'
          : ['disbursed', 'partially-repaid'].includes(stateKey)
            ? 'active'
            : ['overdue'].includes(stateKey)
              ? 'overdue'
              : ['fully-repaid'].includes(stateKey)
                ? 'completed'
                : stateKey,
    memberProfile: {
      ...applicant,
      group: group.name,
      governmentIdType: 'National ID',
    },
    groupProfile: group,
    eligibility: {
      currentSavings,
      protectedSavingsPercentage,
      protectedAmount,
      eligibleAmount,
    },
    loanSummary: {
      requestedAmount,
      approvedAmount,
      interestRate,
      termMonths,
      repaymentFrequency,
      interest,
      fees,
      totalPayable,
      repaymentAmount,
      outstandingBalance: outstandingAmount,
      amountPaid: safeAmountPaid,
      completionDate,
      rejectionReason,
      cancelledReason,
    },
    collateral: collateralByIndex[applicantIndex % collateralByIndex.length],
    guarantors: createGuarantors(guarantorApprovals, rejectedBy, rejectionReason),
    contract: {
      reference: `CNT-${referenceNumber}`,
      status: finalContractStatus,
      generatedAt: contractGeneratedAt || applicationDate,
      startDate: '2026-08-15',
      endDate: `2027-${String(2 + termMonths).padStart(2, '0')}-15`,
      canSign: false,
      notes: finalContractStatus === 'Not Generated'
        ? 'The contract will be generated after system eligibility review.'
        : 'The system generated this contract before group leadership approvals.',
    },
    bellicksReview: {
      reference: `BLF-${referenceNumber}`,
      submissionDate: applicationDate,
      stage: reviewStage || currentStage,
      reviewer,
      status: reviewStatus || (stateKey === 'rejected' ? 'Rejected' : ['approved', 'disbursed', 'partially-repaid', 'overdue', 'fully-repaid'].includes(stateKey) ? 'Approved' : 'In Review'),
      notes: reviewNotes || 'Application is being reviewed against affordability, savings, guarantor and contract readiness.',
      decisionDate: ['approved', 'disbursed', 'partially-repaid', 'overdue', 'fully-repaid', 'rejected'].includes(stateKey) ? lastUpdated : null,
      rejectionReason,
    },
    disbursement: {
      status: isCompleted || isDisbursed ? 'Disbursed' : stateKey === 'approved' ? 'Pending Disbursement' : 'Not Disbursed',
      approvedAmount,
      disbursementDate: isDisbursed || isCompleted ? '2026-08-16' : null,
      expectedDate: stateKey === 'approved' ? '2026-08-18' : null,
      destination: 'NMB bank account',
      reference: isDisbursed || isCompleted ? `TRX-${referenceNumber.slice(-6)}` : '-',
      feesDeducted: fees,
      netAmount: Math.max(approvedAmount - fees, 0),
    },
    repayment: {
      principal: approvedAmount,
      interest,
      charges: fees,
      totalPayable,
      amountPaid: isCompleted ? totalPayable : safeAmountPaid,
      outstandingAmount: isCompleted ? 0 : outstandingAmount,
      nextDueDate: isCompleted ? '-' : '2026-09-15',
      daysRemaining: isCompleted ? 0 : 10,
      overdueAmount,
      overdueDays,
      missedInstallment: overdueAmount > 0 ? repaymentSchedule.find((item) => item.status === 'Overdue')?.installment : null,
      progressPercentage: totalPayable > 0 ? Math.round(((isCompleted ? totalPayable : safeAmountPaid) / totalPayable) * 100) : 0,
    },
    repaymentSchedule: isDisbursed || isCompleted ? repaymentSchedule : [],
    history: [
      { date: applicationDate, label: 'Application created', actor: applicant.memberName },
      guarantorApprovals > 0 ? { date: '2026-08-02', label: 'Guarantor approval started', actor: group.leader } : null,
      rejectedBy ? { date: lastUpdated, label: `Application rejected by ${rejectedBy}`, actor: rejectedBy } : null,
      stateKey === 'rejected' && !rejectedBy ? { date: lastUpdated, label: 'Application rejected', actor: reviewer } : null,
      isCompleted ? { date: completionDate, label: 'Loan completed', actor: applicant.memberName } : null,
    ].filter(Boolean),
  };
};

export const externalLoanMockApplications = [
  createSnapshot({ id: 'mock-eligible', referenceNumber: 'BLK-EXT-2026-0148', stateKey: 'eligible', applicantIndex: 0, groupIndex: 0, requestedAmount: 0, approvedAmount: 0, currentSavings: 1000000, fees: 0, interestRate: 0, amountPaid: 0, guarantorApprovals: 0, applicationDate: '2026-08-01', lastUpdated: '2026-08-01 09:30', status: 'Eligible', currentStage: 'Eligible - Not Applied', contractStatus: 'Not Generated', reviewStatus: 'Not Submitted', reviewStage: 'Not Submitted', reviewNotes: 'Member is eligible to start a new external loan application.' }),
  createSnapshot({ id: 'mock-draft', referenceNumber: 'BLK-EXT-2026-0112', stateKey: 'draft', applicantIndex: 1, groupIndex: 1, requestedAmount: 320000, currentSavings: 650000, amountPaid: 0, guarantorApprovals: 0, applicationDate: '2026-07-25', lastUpdated: '2026-07-26', status: 'Draft', currentStage: 'Draft Application', contractStatus: 'Not Generated', reviewStatus: 'Not Submitted', reviewStage: 'Draft saved', reviewNotes: 'Applicant has saved loan details but has not submitted the request.' }),
  createSnapshot({ id: 'mock-chairperson-pending', referenceNumber: 'BLK-EXT-2026-0107', stateKey: 'awaiting-chairperson', applicantIndex: 4, groupIndex: 0, requestedAmount: 500000, currentSavings: 850000, guarantorApprovals: 0, applicationDate: '2026-07-22', lastUpdated: '2026-07-22 14:20', status: 'Awaiting Guarantors', currentStage: 'Chairperson Approval Pending', contractStatus: 'Draft', reviewStatus: 'Submitted', reviewStage: 'Internal guarantor approvals' }),
  createSnapshot({ id: 'mock-awaiting-guarantors', referenceNumber: 'BLK-EXT-2026-0094', stateKey: 'awaiting-secretary', applicantIndex: 2, groupIndex: 2, requestedAmount: 780000, currentSavings: 1200000, guarantorApprovals: 1, applicationDate: '2026-07-18', lastUpdated: '2026-07-20', status: 'Awaiting Guarantors', currentStage: 'Secretary Approval Pending', contractStatus: 'Draft', reviewStatus: 'Submitted', reviewStage: 'Internal guarantor approvals' }),
  createSnapshot({ id: 'mock-accountant-pending', referenceNumber: 'BLK-EXT-2026-0091', stateKey: 'awaiting-accountant', applicantIndex: 5, groupIndex: 1, requestedAmount: 640000, currentSavings: 980000, guarantorApprovals: 2, applicationDate: '2026-07-16', lastUpdated: '2026-07-18', status: 'Awaiting Guarantors', currentStage: 'Accountant Approval Pending', contractStatus: 'Draft', reviewStatus: 'Submitted', reviewStage: 'Internal guarantor approvals' }),
  createSnapshot({ id: 'mock-under-review', referenceNumber: 'BLK-EXT-2026-0073', stateKey: 'gm-review', applicantIndex: 4, groupIndex: 0, requestedAmount: 460000, currentSavings: 720000, guarantorApprovals: 3, applicationDate: '2026-07-05', lastUpdated: '2026-07-07', status: 'Under Review', currentStage: 'Bellicks Finance Review', contractStatus: 'Signed', acceptedAt: '2026-07-06 16:10', reviewStatus: 'In Review', reviewStage: 'Credit committee assessment' }),
  createSnapshot({ id: 'mock-approved', referenceNumber: 'BLK-EXT-2026-0062', stateKey: 'approved', applicantIndex: 5, groupIndex: 1, requestedAmount: 900000, approvedAmount: 880000, currentSavings: 1400000, guarantorApprovals: 3, applicationDate: '2026-06-28', lastUpdated: '2026-07-02', status: 'Approved', currentStage: 'Pending Disbursement', contractStatus: 'Signed', acceptedAt: '2026-07-01 09:20', reviewStatus: 'Approved', reviewStage: 'Approved - awaiting disbursement', reviewNotes: 'Approved with a small reduction after affordability review.' }),
  createSnapshot({ id: 'mock-disbursed', referenceNumber: 'BLK-EXT-2026-0051', stateKey: 'disbursed', applicantIndex: 6, groupIndex: 2, requestedAmount: 650000, currentSavings: 990000, guarantorApprovals: 3, applicationDate: '2026-06-18', lastUpdated: '2026-06-22', status: 'Disbursed', currentStage: 'Repayment Not Started', contractStatus: 'Signed', acceptedAt: '2026-06-20 12:45', amountPaid: 0, reviewStatus: 'Approved', reviewStage: 'Disbursed' }),
  createSnapshot({ id: 'mock-partial', referenceNumber: 'BLK-EXT-2026-0044', stateKey: 'partially-repaid', applicantIndex: 7, groupIndex: 3, requestedAmount: 720000, currentSavings: 930000, guarantorApprovals: 3, applicationDate: '2026-06-02', lastUpdated: '2026-07-15', status: 'Repayment Active', currentStage: 'Partially Repaid', contractStatus: 'Signed', amountPaid: 280000, reviewStatus: 'Approved', reviewStage: 'Repayment monitoring' }),
  createSnapshot({ id: 'mock-overdue', referenceNumber: 'BLK-EXT-2026-0038', stateKey: 'overdue', applicantIndex: 8, groupIndex: 0, requestedAmount: 580000, currentSavings: 840000, guarantorApprovals: 3, applicationDate: '2026-05-21', lastUpdated: '2026-07-19', status: 'Overdue', currentStage: 'Missed Installment', contractStatus: 'Signed', amountPaid: 120000, overdueAmount: 98000, overdueDays: 8, reviewStatus: 'Approved', reviewStage: 'Collections follow-up' }),
  createSnapshot({ id: 'mock-completed', referenceNumber: 'BLK-EXT-2026-0027', stateKey: 'fully-repaid', applicantIndex: 9, groupIndex: 1, requestedAmount: 410000, currentSavings: 760000, guarantorApprovals: 3, applicationDate: '2026-04-10', lastUpdated: '2026-07-10', status: 'Completed', currentStage: 'Fully Repaid', contractStatus: 'Signed', amountPaid: 484200, completionDate: '2026-07-10', reviewStatus: 'Approved', reviewStage: 'Completed' }),
  createSnapshot({ id: 'mock-rejected-chairperson', referenceNumber: 'BLK-EXT-2026-0024', stateKey: 'rejected', applicantIndex: 10, groupIndex: 2, requestedAmount: 430000, currentSavings: 620000, guarantorApprovals: 0, rejectedBy: 'Chairperson', applicationDate: '2026-04-03', lastUpdated: '2026-04-04', status: 'Rejected', currentStage: 'Decision Issued', contractStatus: 'Archived', reviewStatus: 'Rejected', reviewStage: 'Chairperson decision', rejectionReason: 'Chairperson rejected the request because group records require reconciliation first.' }),
  createSnapshot({ id: 'mock-rejected-secretary', referenceNumber: 'BLK-EXT-2026-0022', stateKey: 'rejected', applicantIndex: 11, groupIndex: 3, requestedAmount: 360000, currentSavings: 630000, guarantorApprovals: 1, rejectedBy: 'Secretary', applicationDate: '2026-04-01', lastUpdated: '2026-04-02', status: 'Rejected', currentStage: 'Decision Issued', contractStatus: 'Archived', reviewStatus: 'Rejected', reviewStage: 'Secretary decision', rejectionReason: 'Secretary rejected the request because member documentation was incomplete.' }),
  createSnapshot({ id: 'mock-rejected-accountant', referenceNumber: 'BLK-EXT-2026-0021', stateKey: 'rejected', applicantIndex: 12, groupIndex: 0, requestedAmount: 390000, currentSavings: 690000, guarantorApprovals: 2, rejectedBy: 'Accountant', applicationDate: '2026-03-29', lastUpdated: '2026-03-30', status: 'Rejected', currentStage: 'Decision Issued', contractStatus: 'Archived', reviewStatus: 'Rejected', reviewStage: 'Accountant decision', rejectionReason: 'Accountant rejected the request because repayment exposure exceeded internal limit.' }),
  createSnapshot({ id: 'mock-rejected', referenceNumber: 'BLK-EXT-2026-0019', stateKey: 'rejected', applicantIndex: 10, groupIndex: 2, requestedAmount: 820000, currentSavings: 700000, guarantorApprovals: 3, applicationDate: '2026-03-26', lastUpdated: '2026-03-31', status: 'Rejected', currentStage: 'Decision Issued', contractStatus: 'Archived', reviewStatus: 'Rejected', reviewStage: 'Credit decision', reviewNotes: 'Application did not satisfy affordability and repayment capacity checks.', rejectionReason: 'Requested amount exceeded approved affordability threshold for the current savings profile.' }),
  createSnapshot({ id: 'mock-needs-info', referenceNumber: 'BLK-EXT-2026-0014', stateKey: 'validation-failed', applicantIndex: 11, groupIndex: 3, requestedAmount: 350000, currentSavings: 610000, guarantorApprovals: 0, applicationDate: '2026-03-18', lastUpdated: '2026-03-19', status: 'Needs Attention', currentStage: 'Additional Information Required', contractStatus: 'Not Generated', reviewStatus: 'Needs Information', reviewStage: 'Validation failed', reviewNotes: 'Applicant must update collateral description before submission can proceed.' }),
  createSnapshot({ id: 'mock-cancelled', referenceNumber: 'BLK-EXT-2026-0008', stateKey: 'cancelled', applicantIndex: 12, groupIndex: 0, requestedAmount: 280000, currentSavings: 580000, guarantorApprovals: 0, applicationDate: '2026-02-12', lastUpdated: '2026-02-13', status: 'Cancelled', currentStage: 'Cancelled by Member', contractStatus: 'Archived', reviewStatus: 'Cancelled', reviewStage: 'Cancelled before review', cancelledReason: 'Member withdrew the request before guarantor approval.' }),
];

export const externalLoanApplicantProfileFixtures = [
  {
    key: 'nida',
    label: 'NIDA profile',
    fullName: 'Amina Mbarak',
    phoneNumber: '+255 712 345 678',
    governmentIdType: 'National ID',
    governmentIdNumber: '19900101-12345-00001-12',
    groupName: 'Mwanza Savings Circle',
    memberReference: 'SVY-10482',
  },
  {
    key: 'voter',
    label: 'Voter ID profile',
    fullName: 'Hassan Juma',
    phoneNumber: '+255 754 221 780',
    governmentIdType: 'Voter ID',
    governmentIdNumber: 'VTR-2024-841925',
    groupName: 'Umoja Savings Group',
    memberReference: 'SVY-10517',
  },
  {
    key: 'missing-identity',
    label: 'Missing ID profile',
    fullName: 'Rehema Abdallah',
    phoneNumber: '+255 716 334 850',
    governmentIdType: '',
    governmentIdNumber: '',
    groupName: 'Mbeya Teachers Saccos',
    memberReference: 'SVY-12177',
  },
];

export const externalLoanCollateralCoverageFixtures = [
  {
    key: 'sufficient',
    label: 'Sufficient coverage',
    currentSavings: 1000000,
    protectedSavings: 200000,
  },
  {
    key: 'insufficient',
    label: 'Insufficient coverage',
    currentSavings: 700000,
    protectedSavings: 200000,
  },
];

export const calculateCollateralCoverage = (coverageSource = {}, requestedAmount = 0) => {
  const currentSavings = money(coverageSource.currentSavings);
  const protectedSavings = money(coverageSource.protectedSavings);
  const availableSecurity = Math.max(currentSavings - protectedSavings, 0);
  const safeRequestedAmount = money(requestedAmount);
  const coverageRatio = safeRequestedAmount > 0 ? Number(((availableSecurity / safeRequestedAmount) * 100).toFixed(1)) : 0;
  const isSufficient = safeRequestedAmount > 0 && availableSecurity >= safeRequestedAmount;

  return {
    key: coverageSource.key,
    label: coverageSource.label,
    currentSavings,
    protectedSavings,
    availableSecurity,
    requestedAmount: safeRequestedAmount,
    coverageRatio,
    status: isSufficient ? 'SUFFICIENT' : 'INSUFFICIENT',
  };
};

export const externalLoanApplicationDraftFixture = {
  loanDetails: {
    amount: 650000,
    dailyInterestRatePercent: EXTERNAL_LOAN_DEFAULT_DAILY_INTEREST_RATE_PERCENT,
    repaymentTerm: 6,
    repaymentFrequency: EXTERNAL_LOAN_REPAYMENT_FREQUENCY_DAILY,
    interestPlan: EXTERNAL_LOAN_STANDARD_INTEREST_PLAN,
    purpose: 'Business expansion',
    notes: 'Additional stock and refrigerator equipment for the retail shop.',
  },
  applicantProfile: externalLoanApplicantProfileFixtures[0],
  collateralCoverage: calculateCollateralCoverage(externalLoanCollateralCoverageFixtures[0], 650000),
  guarantors: [
    { role: 'Chairperson', name: 'Joseph Msuya', phoneNumber: '+255 714 112 233', verificationStatus: 'Verified group leader', acknowledgementStatus: 'Ready for approval after submission' },
    { role: 'Secretary', name: 'Ruth Kileo', phoneNumber: '+255 715 778 899', verificationStatus: 'Verified group leader', acknowledgementStatus: 'Ready for approval after submission' },
    { role: 'Accountant', name: 'Daniel Masanja', phoneNumber: '+255 716 445 566', verificationStatus: 'Verified group leader', acknowledgementStatus: 'Ready for approval after submission' },
  ],
  declarations: {
    informationConfirmed: false,
    approvalFlowAcknowledged: false,
  },
};

export const createMockSubmittedExternalLoanApplication = (draft, options = {}) => {
  const requestedAmount = money(draft.loanDetails?.amount);
  const now = new Date();
  const referenceSeed = String(options.sequence || now.getTime()).slice(-4).padStart(4, '0');
  const referenceNumber = `BLK-EXT-${now.getFullYear()}-${referenceSeed}`;
  const currentSavings = Math.max(
    money(options.currentSavings),
    money(requestedAmount / (1 - EXTERNAL_LOAN_PROTECTED_SAVINGS_PERCENTAGE)),
  );
  const baseSnapshot = createSnapshot({
    id: `mock-submitted-${referenceSeed}`,
    referenceNumber,
    stateKey: 'submitted',
    applicantIndex: 0,
    groupIndex: 0,
    requestedAmount,
    currentSavings,
    guarantorApprovals: 0,
    applicationDate: now.toISOString().slice(0, 10),
    lastUpdated: now.toISOString().slice(0, 16).replace('T', ' '),
    status: 'Submitted',
    currentStage: 'System Eligibility Review',
    contractStatus: 'Generated',
    reviewStatus: 'Submitted',
    reviewStage: 'System eligibility review',
    reviewNotes: 'Mock application submitted locally for UI review. No live API call was made.',
  });
  const applicantProfile = draft.applicantProfile || {};
  const collateralCoverage = calculateCollateralCoverage(draft.collateralCoverage || externalLoanApplicationDraftFixture.collateralCoverage, requestedAmount);

  return {
    ...baseSnapshot,
    applicant: applicantProfile.fullName || baseSnapshot.applicant,
    memberProfile: {
      ...baseSnapshot.memberProfile,
      memberName: applicantProfile.fullName || baseSnapshot.memberProfile.memberName,
      phoneNumber: applicantProfile.phoneNumber || baseSnapshot.memberProfile.phoneNumber,
      governmentIdType: applicantProfile.governmentIdType || baseSnapshot.memberProfile.governmentIdType,
      governmentIdNumber: applicantProfile.governmentIdNumber || baseSnapshot.memberProfile.governmentIdNumber,
      memberReference: applicantProfile.memberReference || baseSnapshot.memberProfile.memberReference,
      group: applicantProfile.groupName || baseSnapshot.memberProfile.group,
    },
    groupProfile: {
      ...baseSnapshot.groupProfile,
      name: applicantProfile.groupName || baseSnapshot.groupProfile.name,
    },
    collateral: {
      type: 'Savings Security',
      description: `Eligible group savings coverage: ${collateralCoverage.status}`,
      estimatedValue: collateralCoverage.availableSecurity,
    },
    collateralCoverage,
    guarantors: (draft.guarantors || externalLoanApplicationDraftFixture.guarantors).map((guarantor) => ({
      role: guarantor.role,
      name: guarantor.name,
      phone: guarantor.phoneNumber || guarantor.phone,
      approved: false,
      approvedAt: null,
      verificationStatus: guarantor.verificationStatus,
      acknowledgementStatus: guarantor.acknowledgementStatus,
    })),
  };
};

export const createMockApplicationSnapshot = (stateConfig) => {
  const match = externalLoanMockApplications.find((application) => application.stateKey === stateConfig.key);
  return match || externalLoanMockApplications[0];
};
